// Démarre le flux OIDC Authorization Code + PKCE :
// génère les paramètres côté client, demande l'URL d'autorisation au serveur,
// puis redirige le navigateur vers le fournisseur d'identité.

import {
  generateCodeChallenge,
  generateCodeVerifier,
  generateNonce,
  generateState,
} from './pkce';
import { saveOidcSession } from './session';
import { invokeOidcFunction } from './invoke';

interface LoginResponse {
  authorizationUrl: string;
}

/**
 * Lance la redirection vers le fournisseur OIDC.
 * @throws si l'Edge Function échoue (config manquante, provider inaccessible…)
 */
export async function login(): Promise<void> {
  const codeVerifier = generateCodeVerifier();
  const codeChallenge = await generateCodeChallenge(codeVerifier);
  const state = generateState();
  const nonce = generateNonce();

  // Sauvegardé AVANT la redirection : requis au retour sur /auth/callback
  saveOidcSession({ codeVerifier, state, nonce });

  const { authorizationUrl } = await invokeOidcFunction<LoginResponse>('oidc-login', {
    code_challenge: codeChallenge,
    state,
    nonce,
  });

  window.location.href = authorizationUrl;
}
